define.alias("shared/components/shared/wizard/previous-button", "settings/components/shared/wizard/previous-button");